import { render, staticRenderFns } from "./ModalEditPassword.vue?vue&type=template&id=209b1655&scoped=true&lang=true&"
import script from "./ModalEditPassword.vue?vue&type=script&lang=js&"
export * from "./ModalEditPassword.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditPassword.vue?vue&type=style&index=0&id=209b1655&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209b1655",
  null
  
)

export default component.exports